import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import { formatBackendDateToMonthYear } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type { Cycle } from 'modules/timeoff/store/models/AllowanceStat'

import CycleExplainer from './CycleExplainer'

class CycleForm extends Form {
  constructor(values: {}) {
    super(values, {
      cycle_id: 'string',
    })
  }
}

interface Props {
  cycles: Cycle[]
  currentCycle: Cycle
  selectedCycle: Cycle
  onSelect: (id: string) => void
}

const CycleSelector = ({ cycles, currentCycle, selectedCycle, onSelect }: Props) => {
  const form = new CycleForm({
    cycle_id: selectedCycle.id,
  })

  const options = cycles.map((cycle) => {
    const { begin, end } = cycle
    const startDate = formatBackendDateToMonthYear(begin)
    const endDate = formatBackendDateToMonthYear(end)

    const params = {
      startDate,
      endDate,
    }

    const label =
      cycle === currentCycle
        ? i18n.t('time_off.new_counter.counter_cycles.options.current', params)
        : i18n.t('time_off.new_counter.counter_cycles.options.others', params)

    return {
      value: cycle.id,
      label: label,
    }
  })

  return (
    <Box background="grey100" width="full" gap="s8" textAlign="left" paddingY="s24" paddingX="s16">
      <Box>
        <Box flexDirection="row" gap="s8">
          <Text.Normal color="grey800" weight="medium">
            {i18n.t('time_off.new_counter.counter_cycles.choose')}
          </Text.Normal>
          <CycleExplainer />
        </Box>
        <Text.Normal>{i18n.t('time_off.new_counter.counter_cycles.select')}</Text.Normal>
      </Box>
      <Box>
        <Select
          field={form.get('cycle_id')}
          options={options}
          onChange={(field: any) => onSelect(field.value)}
          showOriginalLabelText
        />
      </Box>
    </Box>
  )
}

export default observer(CycleSelector)
